// Legal expert specialization value keys and their i18n label resolution.
// The translated labels live under the "EDIT_EXPERT_PAGE_SPECIALIZATION_*" keys
// in the locale files and are reused everywhere a specialization is displayed.

export const SPECIALIZATION_KEYS: string[] = [
  "CORPORATE_LAW",
  "CRIMINAL_LAW",
  "FAMILY_LAW",
  "INTELLECTUAL_PROPERTY",
  "TAX_LAW",
  "ENVIRONMENTAL_LAW",
  "LABOR_LAW",
  "REAL_ESTATE_LAW",
  "IMMIGRATION_LAW",
  "CONSTITUTIONAL_LAW",
];

/**
 * Resolve the i18n labelKey from a specialization value key.
 * Falls back to the raw value so an unknown/legacy code still renders as-is
 * (t() returns the passed string when no matching translation exists).
 */
export function getSpecializationLabelKey(value: string): string {
  return SPECIALIZATION_KEYS.includes(value)
    ? `EDIT_EXPERT_PAGE_SPECIALIZATION_${value}`
    : value;
}
